import { MenuItem } from './menu-item';

/**
 * Entidad que representa el encabezado del menú
 */
export interface Menu {
  /**
   * Coleccion de items del menú
   */
  menuItems: MenuItem[];

  /**
   * Nombre del menú
   */
  name: string;
}
